<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col sm="7">
            <ModuleViewHeading
              :module-id="access.module_id"
              :profile-id="access.profile_id"
              :reference="access.view_reference"
            />
          </b-col>

          <b-col sm="5">
            <b-button @click="add()" type="button" variant="primary" size="sm" class="btn-pill float-right ml-2" v-b-tooltip.hover title="Agregar Informe">
              <i class="fa fa-plus"></i> Agregar
            </b-button>

            <b-col sm="12" class="d-none d-md-block" v-if="!table.mostrarFiltros">
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" @click="table.mostrarFiltros=true" v-b-tooltip.hover title="Mostrar filtros">
                <i class="fa fa-filter"></i> Mostrar Filtros
              </b-button>
            </b-col>
            <b-col sm="12" class="d-none d-md-block" v-else>
              <b-button type="button" variant="outline-dark" size="sm" class="btn-pill float-right" v-if="table.mostrarFiltros" @click="table.mostrarFiltros=false" v-b-tooltip.hover title="Ocultar filtros">
                <i class="fa fa-window-close"></i>
              </b-button>
            </b-col>
          </b-col>          
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row v-if="table.mostrarFiltros">
          <b-col sm="3">
            <b-row>
              <b-col md="6" class="pr-0">
                <b-form-input type="date" size="md" v-model="filter.date_start" placeholder="Fecha Desde"></b-form-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <b-form-input type="date" size="md" v-model="filter.date_end" placeholder="Fecha Hasta"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="6">
            <b-row>
              <b-col sm="4">
                <v-select :options="arr.filter.staff" v-model="filter.staff" placeholder="Staff" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>            
              <b-col sm="4">
                <v-select :options="arr.filter.customers" v-model="filter.customers" placeholder="Clientes" :multiple="true" :select-on-tab="true"></v-select>
              </b-col>       
              <b-col sm="4">
                <v-select :options="arr.filter.read" v-model="filter.read" placeholder="Leido" :multiple="false" :select-on-tab="true"></v-select>                
              </b-col>               
            </b-row>
          </b-col>
          <b-col sm="1">
            <b-button variant="outline-dark" @click="filterReport()">
              <b-icon icon="filter" class="mr-1" style="font-size:15px;"></b-icon>              
              Filtrar
            </b-button>
          </b-col>
          <b-col sm="2">
            <b-link>
              <export-excel
                class = 'pull-right mt-3'
                :data = "arr.export"
                worksheet = "Informe de Servicios"
                name = "reports-services.xls">
                Exportar Datos
              </export-excel>            
            </b-link>
          </b-col>
        </b-row>

        <b-row class="mt-3">
          <b-col>
            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="formartedItems"
                    :fields="table.fields"                    
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(date)="data">
                  {{ moment(data.item.date).format('DD MMMM YYYY') }}
                </template>

                <template v-slot:cell(responsable)="data">
                  <div v-if="data.item.staff_id">
                    <b-avatar :src="data.item.staff.image"
                              v-if="data.item.staff.image">
                    </b-avatar>
                    <b-avatar v-else                                                                         
                              variant="dark">
                    </b-avatar>                         
                    <b-icon icon="blank"></b-icon>
                    <b :title="'STAFF: ' + data.item.staff.name">
                      {{data.item.staff.name}}
                    </b>                                          
                  </div>                             
                </template>

                <template v-slot:cell(customers)="data">   
                  <div v-if="data.item.customers_id">
                    <b-avatar :src="data.item.customer.image"
                              v-if="data.item.customer.image">
                    </b-avatar>
                    <b-avatar v-else 
                              icon="building"                                            
                              variant="dark">
                    </b-avatar>     
                    &nbsp;<b>{{data.item.customer.name}}</b>      
                    <b-icon icon="circle-fill" v-if="!data.item.customer.active" class="ml-2" variant="danger" v-b-tooltip.hover title="Cliente INACTIVO" />
                  </div>
                </template>

                <template v-slot:cell(read)="data">
                  <b-icon icon="toggle-on"  @click="checkRead(data.item)" class="h4 report-services-check-read-table" v-if="!data.item.read" v-b-tooltip.hover title="Sin Leer"></b-icon>
                  <b-icon icon="toggle-off" class="h4" v-else v-b-tooltip.hover title="Leido"></b-icon>
                </template>

                <template v-slot:cell(observations)="data">
                  <div v-if="data.item.observations">
                    <div v-if="data.item.observations.length >50" :title="data.item.observations">
                      {{data.item.observations.substr(0, 50)}}
                    </div>
                    <div v-else>
                      {{data.item.observations}}
                    </div>
                  </div>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right text="Acción" size="sm" variant="outline-dark" class="pull-right">

                    <b-dropdown-item @click="irDetail(data.item)">
                      <b-icon icon="card-text"></b-icon> Detalle
                    </b-dropdown-item>       

                    <b-dropdown-item @click="checkRead(data.item)" v-if="!data.item.read">
                      <b-icon icon="eye-fill"></b-icon> Marcar como leido
                    </b-dropdown-item>       
                    <b-dropdown-item @click="checkNotRead(data.item)" v-if="data.item.read">
                      <b-icon icon="eye-slash-fill"></b-icon> Marcar como no leido
                    </b-dropdown-item>                           

                    <b-dropdown-item @click="sendPrinterOrder(data.item)">
                      <b-icon icon="printer"></b-icon> Imprimir
                    </b-dropdown-item>    

                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)" v-if="access.elements.editReport">
                      <i class="fa fa-pencil ml-0 mr-0" style="color:blue"></i> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)" v-if="access.elements.deleteReport">
                      <i class="fa fa-trash mr-0 ml-0" style="color:red"></i> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            <b-alert v-else variant="warning" show>No se encontraron registros</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>                        
          </b-col>

          <b-col>
            <nav>
              <b-pagination class="pull-right mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(formartedItems)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
            </nav>
          </b-col>          
        </b-row>
      </b-card>

      <!--
      ###########################
      ######### PRINTER #########
      ###########################
      -->
      <Printer v-if="crud.print.id" 
              :reference="crud.print.reference" 
              :registerID="crud.print.id"
              :key="crud.print.key"/>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              header-bg-variant="dark"
              header-text-variant="white"
              no-close-on-esc
              no-close-on-backdrop
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize>
          {{this.modal.form.title}}
        </div>

        <b-row>      
          <b-col md="12">
            <b-form-group label="Fecha">
              <b-form-datepicker size="sm" v-model="crud.form.date" placeholder="Fecha" local="es"></b-form-datepicker>                      
            </b-form-group>            
          </b-col>

          <b-col md="12">
            <FindObject render="search"
                        type="customers" 
                        @select-object="loadCustomers($event)" 
                        :valueID="crud.form.customers_id"/>           
          </b-col>    

          <b-col md="12">
            <b-form-group label="Observaciones">
              <app-textarea                
                v-model="crud.form.observations"
                placeholder="Ingresar las observaciones..."
                rows="3"
                max-rows="6"
              ></app-textarea>
            </b-form-group>
          </b-col>         
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()">Guardar</b-button>          
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'  
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper' 
  import moment from 'moment'
  import FindObject from '@/components/inc/find/findObject' 
  import Vue from 'vue'
  import excel from 'vue-excel-export'
  import Storage from '@/handler/storageSession'
  import Printer from '@/components/inc/printer/printer'

  Vue.use(excel)

  export default {
    components: {
      FindObject,
      Printer
    },      
    data: () => {
      return {      
        access: {
          module_id: Modules.INFORME_SERVICIOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudReport',
          elements: {
            editReport: true,
            deleteReport: true             
          }
        }, 
        table : {
          items: [],
          fields: [
            {key: 'id', label: 'ID', sortable: true, class: "align-middle"},
            {key: 'date', label: 'Fecha', class: "align-middle"},
            {key: 'responsable', label: 'Responsable', class: "align-middle"},
            {key: 'customers', label: 'Cliente', class: "align-middle"},
            {key: 'observations', label: 'Observaciones', class: "align-middle"},
            {key: 'read', label: 'Estado', class: "align-middle text-center"},
            {key: 'f_action', label:'', class: "align-middle"},
          ],          
          mostrarFiltros: true,
          currentPage: 1,
          perPage: 50,
        },
        crud: {
          form: {
            id: 0,
            date: '',
            observations: '',            
            staff_id: 0,
            customers_id: 0,
            customers: null,
            read: false,
          },     
          print: {
            reference: 'reports-service',
            id: 0,
            key: 0,
          }       
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        },
        arr: {
          export: [],
          filter : {
            customers: [],
            staff: [],
            read: [
              {code:true, label: 'Leido'},
              {code:false, label: 'No Leidos'},                            
            ],
          }
        },
        filter: {
          date_start: '',
          date_end: '',
          customers: [],
          staff: [],
          read: null,
        },   
        customersID: 0,  
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.editReport = Helper.hasAccessElement(this.access, 'edit_report')
      this.access.elements.deleteReport = Helper.hasAccessElement(this.access, 'delete_report')       
      /* Fin configuracion */
    },  
    mounted() {      
      this.customersID = this.$route.params.customersID
      if(this.customersID) {
        this.validCustomers()
      }

      this.filterLoad()
      this.filterReport()
    },
    computed: {
      formartedItems () {
        if (!this.table.items) return []
        return this.table.items.map(item => {
          if(!item.read){
            item._rowVariant  = 'active'
          }
          return item
        })
      }
    },    
    methods: {
      validCustomers() {        
        this.add()
        this.crud.form.customers_id = this.customersID
      },

      getRowCount (items) {
        return items.length
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.date = moment().format('YYYY-MM-DD')
        this.crud.form.observations = ''
        this.crud.form.staff_id = Helper.getStaffId()
        this.crud.form.customers_id = 0
        this.crud.form.customers = null
        this.crud.form.read = false

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nuevo Reporte"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.date = item.date 
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.read = item.read
                
        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Reporte"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.customers = item.customer

        this.$bvModal.msgBoxConfirm('¿Desea borrar el item (' + this.crud.form.id + ') realizado al cliente ('+ this.crud.form.customers.name + ')?', {
          title: 'Borrar Reporte',
          size: 'lg',
          buttonSize: 'lg',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          headerBgVariant: 'danger',
          headerTextVariant: 'white',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminar(this.crud.form.id);

            result.then((response) => {      
              this.modal.form.active = false        
              loader.hide()
              this.filterReport()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        this.$bvModal.msgBoxConfirm('¿Desea continuar con la operación?', {
          title: 'Guardar Reporte',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'dark',
          okTitle: 'Aceptar',
          cancelVariant: 'outline-dark',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          headerBgVariant: 'dark',
          headerTextVariant: 'black',
          hideHeaderClose: false,
          centered: false
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            if (this.crud.form.id) {
              var result = serviceAPI.editar(this.crud.form);
            } else {
              var result = serviceAPI.agregar(this.crud.form);
            }

            result.then((response) => {
              this.modal.form.active = false
              loader.hide()
              this.filterReport()
              this.$awn.success("Datos guardados con éxito");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })            
      },
      loadCustomers (object) {        
        if(object){
          this.crud.form.customers = object
          this.crud.form.customers_id = object.id        
        } else {
          this.crud.form.customers = null
          this.crud.form.customers_id = 0
        }
      }, 
      
      filterLoad() {
        this.filterLoadCustomers()
        this.filterLoadStaff()             
        this.filter.date_start = moment().subtract(7, 'days').format('YYYY-MM-DD') 
        this.filter.date_end = moment().format('YYYY-MM-DD') 

        this.restoreFilterStorage() 
      },
      filterLoadCustomers() {
        var result = serviceAPI.obtenerClientes()        
        result.then((response) => {
          var data = response.data    

          this.arr.filter.customers = []
          data.forEach(element => {            
            this.arr.filter.customers.push({ code: element.id, label: element.name })            
          });          
        })   
      },
      filterLoadStaff() {
        var result = serviceAPI.obtenerStaff()        
        result.then((response) => {
          var data = response.data    

          this.arr.filter.staff = []
          data.forEach(element => {                            
            if(!element.seller) {             
              this.arr.filter.staff.push({ code: element.id, label: element.name })    
            }                    
          });          
        })   
      },      
      filterReport(){
        let loader = this.$loading.show()   
   
        var result = serviceAPI.filtrarReport(this.filter)        
        result.then((response) => {
          loader.hide()

          var data = response.data
          this.table.items = data
          this.prepareExport(data)
        })
        .catch(error => {          
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });          
      }, 
      prepareExport(data) {
        data.forEach(element => {
          var staffID = 0            
          var staffName = ''
          var customersID = 0
          var customersCode = ''
          var customersName = ''

          if(element.staff_id) {
            staffID = element.staff.id
            staffName = element.staff.name
          } 

          if(element.customers_id) {
            customersID = element.customer.id
            customersCode = element.customer.code
            customersName = element.customer.name            
          }

          this.arr.export.push({
            id: element.id,
            date: element.date,
            staffID: staffID,
            staffName: staffName,
            customersID: customersID,
            customersCode: customersCode,
            customersName: customersName,
            observations: element.observations
          })
        });
      },

      checkRead(item) {
        let loader = this.$loading.show();     
        
        this.crud.form.id = item.id
        this.crud.form.date = item.date 
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.read = true
        
        var result = serviceAPI.editar(this.crud.form);
      
        result.then((response) => {          
          loader.hide()
          this.filterReport()
          this.$awn.success("Reporte marcado como Leido");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },
      checkNotRead(item) {
        let loader = this.$loading.show();     
        
        this.crud.form.id = item.id
        this.crud.form.date = item.date 
        this.crud.form.observations = item.observations
        this.crud.form.staff_id = item.staff_id
        this.crud.form.customers_id = item.customers_id
        this.crud.form.customers = item.customer
        this.crud.form.read = false
        
        var result = serviceAPI.editar(this.crud.form);
      
        result.then((response) => {          
          loader.hide()
          this.filterReport()
          this.$awn.success("Reporte marcado como No Leido");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })        
      },

      // FILTROS SAVE
      saveFilterStorage() {
        Storage.setValue('filter_report_services', JSON.stringify(this.filter))
      },
      restoreFilterStorage() {
        if(Storage.getValue('filter_report_services')) {
          this.filter = JSON.parse(Storage.getValue('filter_report_services'))
        }         
      },

      irDetail(item){
        this.saveFilterStorage()
        this.$router.push({ name: 'ReportsServicesStaffDetailReport', params: {reportID: item.id} })
      },
      sendPrinterOrder(item) {
        this.crud.print.key=Math.random()
        this.crud.print.id=item.id
      }
    }    
  }
</script>
<style>
  .report-services-crud-icon {
    color: #000 !important;
    margin-right: 0px !important;
    margin-left: 0px !important;
    font-size: 18px;
  }
  .report-services-check-read-table {
    cursor: pointer;
  }  
</style>
<style scoped>
  .b-avatar {
    width: 25px;
    height: 25px;    
  }  
</style>